import autocompleteObserver from './modules/autocompleteObserver-functions';

autocompleteObserver.init();



// WEBPACK FOOTER //
// ./cpanel/js/components/autocomplete/autocompleteObserver.js